Vue.component("tickets-mass-resolve-modal", {
    data() {
        return {
            form: new AppForm({
                selected_close_date: null
            }),
            resolveDateOptions: {
                disabledDate(date) {
                    return date.getTime() > Date.now();
                }
            }
        }
    },
    methods: {
        resetForm() {
            this.form = new AppForm({
                selected_close_date: null
            });
        },
        resolveTickets() {
            App.patch('/tickets/mass-resolve', this.form)
            .then(response => {
                this.hideTicketsResolveModal();
                toastr.success("Tickets have been resolved successfully!");
            }).catch(() => {
                toastr.error("Tickets could not be resolved, please try later!");
            });
        },
        hideTicketsResolveModal() {
            $("#modal-ticket-mass-resolve").modal("hide");
            this.resetForm();
        }
    }
});
